import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import VuexPersistence from 'vuex-persist';

import apiSession from './api_session';
import language from './language';
import xmppClient from './xmpp_client';
import xmppMessaging from './xmpp_messaging';

Vue.use(Vuex);

const localState = new VuexPersistence({
  key: 'join-forms-state',
  storage: window.localStorage,
  modules: [
    'apiSession',
    'language',
  ],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reducer: (state: any) => ({
    apiSession: state.apiSession,
    // serverRegion: {
    //   selected: state.serverRegion.selected,
    // },
  }),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const localStateInit = (vuexStore: Store<any>) => {
  // Initialize localStorage-backed modules
  vuexStore.commit('apiSession/initState');
  vuexStore.commit('language/initState');
};

const store = new Vuex.Store({
  modules: {
    apiSession,
    language,
    xmppClient,
    xmppMessaging
  },
  plugins: [localState.plugin, localStateInit],
});

Vue.prototype.$store = store;

export default store;
